import { render, staticRenderFns } from "./CoursewareBlockCommentsOverview.vue?vue&type=template&id=5d95b49e&"
import script from "./CoursewareBlockCommentsOverview.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockCommentsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports